import { combineReducers } from 'redux';

import signup from '../modules/signup/store';

export default combineReducers({
  signup
});
